import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/auth';

const TeacherStudents = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingStudents, setLoadingStudents] = useState(false);

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/teacher/classes', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const classesList = Array.isArray(res.data) ? res.data : [];
      setClasses(classesList);

      // Sélectionner automatiquement la 1ère classe
      if (classesList.length > 0) {
        setSelectedClass(classesList[0].id);
        fetchStudents(classesList[0].id);
      }
    } catch (err) {
      console.error('Erreur:', err);
      setClasses([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async (classId) => {
    try {
      setLoadingStudents(true);
      const token = localStorage.getItem('token');
      const res = await api.get(`/teacher/classes/${classId}/students`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStudents(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
      setStudents([]);
    } finally {
      setLoadingStudents(false);
    }
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    if (classId) {
      fetchStudents(classId);
    } else {
      setStudents([]);
    }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  };

  if (loading) return <div className="p-6">Chargement...</div>;

  const currentClass = classes.find((c) => c.id == selectedClass);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#2C3E50]">👨‍🎓 Mes élèves</h1>
        <p className="text-gray-500">Consultez les élèves de vos classes</p>
      </div>

      {/* Sélecteur de classe */}
      <div className="bg-white rounded-xl shadow-md p-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          📚 Sélectionner une classe
        </label>
        <select
          value={selectedClass}
          onChange={handleClassChange}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#E67E22]"
        >
          <option value="">-- Choisir une classe --</option>
          {classes.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name} ({c.students_count} élèves)
            </option>
          ))}
        </select>
      </div>

      {/* Info classe */}
      {currentClass && (
        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4">
          <h2 className="text-lg font-bold text-blue-800">{currentClass.name}</h2>
          <p className="text-sm text-blue-600">
            Niveau : {currentClass.level} • {currentClass.students_count} élève(s)
          </p>
        </div>
      )}

      {/* Liste des élèves */}
      {loadingStudents ? (
        <div className="text-center py-8 text-gray-500">Chargement des élèves...</div>
      ) : students.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
          <p className="text-lg mb-2">👥 Aucun élève dans cette classe</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {students.map((student) => (
            <div key={student.id} className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition">
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full bg-[#E67E22] text-white flex items-center justify-center font-bold">
                    {getInitials(student.name)}
                  </div>
                  <div>
                    <h3 className="font-bold text-[#2C3E50]">{student.name}</h3>
                    {student.matricule && (
                      <p className="text-xs text-gray-500">Matricule : {student.matricule}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="mt-4 grid grid-cols-3 gap-2">
                <Link
                  to="/teacher/grades"
                  className="text-center text-xs bg-green-50 hover:bg-green-100 text-green-700 py-2 rounded-lg transition"
                >
                  ✏️ Notes
                </Link>
                <Link
                  to="/teacher/attendance"
                  className="text-center text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 py-2 rounded-lg transition"
                >
                  📋 Appel
                </Link>
                <Link
                  to="/teacher/messages"
                  className="text-center text-xs bg-purple-50 hover:bg-purple-100 text-purple-700 py-2 rounded-lg transition"
                >
                  💬 Parent
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Résumé */}
      {students.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-4">
          <p className="text-sm text-gray-500">
            📊 <strong>{students.length}</strong> élève(s) dans la classe <strong>{currentClass?.name}</strong>
          </p>
        </div>
      )}
    </div>
  );
};

export default TeacherStudents;